var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdeateliveLogoNotextColor = function SvgIdeateliveLogoNotextColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m8.076 3.226-5.912 8.129a.99.99 0 0 0 0 1.09l5.912 8.13c.22.3.575.3.794 0l5.912-8.13a.99.99 0 0 0 0-1.09L8.87 3.226c-.22-.301-.575-.301-.794 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m13.597 17.205 2.45 3.37c.22.3.575.3.794 0l5.912-8.13a.99.99 0 0 0 0-1.09L16.84 3.226c-.22-.301-.575-.301-.794 0l-2.45 3.369 3.462 4.76a.99.99 0 0 1 0 1.09z",
    clipRule: "evenodd"
  })));
};
export default SvgIdeateliveLogoNotextColor;